<template>
  <div class="video-section">
    <div class="section-title">
      <h2>{{ title }}</h2>
    </div>
    <div class="videos-container">
      <div
          class="video-item"
          v-for="video in videos"
          :key="video.id"
      >
        <h5>{{ video.name }}</h5>
        <video-player
            :src="video.src"
            :auto-play="false"
            :controls="true"
            :width="video.width"
            :height="video.height"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoSection',
  props: {
    title: {
      type: String,
      default: ""//VIDEOS: HOW IT WORKS
    },
    videos: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.video-section {
  background-color: #f8f9fa;
  padding: 40px 0;
  text-align: center;
}

.videos-container {
  width: 80%;
  max-width: 1500px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  align-content: center;
}

.video-item {
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.video-item h5 {
  margin-bottom: 15px;
}
</style>
